import { CITATION_LIST_NAME_LOWER_SINGLE } from '@chegg-wt/core/constants/citations'

export const MODAL_TITLE_CREATE_CITATION_LIST = `Create ${CITATION_LIST_NAME_LOWER_SINGLE}`
export const MODAL_TITLE_EDIT_CITATION_LIST = `Edit ${CITATION_LIST_NAME_LOWER_SINGLE}`

type ConfirmType = 'Edit' | 'Create' | 'Save'
type Name = 'create-project' | 'edit-project'

export interface StyleItem {
  value: string
  name: string
}

export interface BaseProjectModalProps {
  id?: string
  title: string
  confirmText: ConfirmType
  name: Name
  currentProjectName?: string
  currentProjectStyle?: string
  styles: StyleItem[]
  action: (defaultStyle: string, name: string, id: string) => void
  close: (name: string) => void
}
